import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Grid } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useFieldArray,  } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CBCreationOfProps, IFormValues } from "../../types";
import { getCountryByCode } from "../../utils";
import CBConsentsAccordion from "./CBConsentsAccordion";

const CustomerBaseConsentDetails = ({creationOf}: CBCreationOfProps) => {

   const { t } = useTranslation('customerbase');  
    const isCreationMode = !!creationOf;
    const [isExpanded, setIsExpanded] = useState(false);
    const consentsFieldArray = useFieldArray<IFormValues, 'cbConsents'>({
        name: "cbConsents"
    });

    const [filteredCompanyCode, setFilteredCompanyCode] = useState<string[]>([]);

    useEffect(() => {
            
            if(isCreationMode) return;
    
            let cc: string[] = []
            consentsFieldArray.fields.forEach((consent) => {
                if(!!consent.companyCode && !cc.includes(consent.companyCode)) {
                    cc.push(consent.companyCode);
                }
            });
            setFilteredCompanyCode(cc);
    
    }, [consentsFieldArray.fields, isCreationMode]);

    return (
        <Accordion expanded={Boolean(isExpanded)} onChange={(_e, expanded) => {
            setIsExpanded(expanded);
            
        }}>  
            <AccordionSummary expandIcon={ <ExpandMore/> }>
                {t("tabs.accordionsLabels.cbConsentDetails")
                /*isCreationMode ? 
                    t("tabs.accordionsLabels.cbConsentDetails") 
                    :
                 <UpdateBtnsAccordion
                    label={t("tabs.accordionsLabels.cbConsentDetails")}
                    editing={editing}
                    isExpanded={isExpanded}
                    disabledSave={formState.dirtyFields.cbConsents ? false : true}
                    onSetEditing={onSetEditing}
                    onResetForm={onResetForm}
                    onSave={onSave}
                    //showAdd={(consentsFieldArray.fields.length >= 0 && consentsFieldArray.fields.length <3)}
                    //onAdd={onAdd}
                />*/}
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1}>
                    {   
                        filteredCompanyCode.map((cc) => (
                            <Fragment key={`fragment-consent-country-${cc}`}>
                                <Grid item xs={12} key={`consent-country-${cc}`}>
                                    <Accordion>
                                        <AccordionSummary expandIcon={ <ExpandMore/>}>
                                            {t(`labels.country.${getCountryByCode(cc)}`, {defaultValue: cc})}
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container rowSpacing={1}>
                                                {
                                                    consentsFieldArray.fields.map((consent, index) => (
                                                        (consent.companyCode == cc) &&
                                                        <Grid item md={12} xs={12} key={`consent-${consent.id}`}>
                                                            <CBConsentsAccordion 
                                                                creationOf={creationOf}
                                                                index={index}
                                                                consent={consent}
                                                            />
                                                        </Grid>
                                                    ))
                                                }
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Fragment>

                        ))
                    }
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default CustomerBaseConsentDetails;